import styled from 'styled-components';

import { ThemeMode } from '@/helpers/enums';

import { device, hexToRGB, typography } from '@/styles/helpers';

export const ScCurrentPaymentMethod = styled.div<{
  mode?: ThemeMode;
}>`
  padding: 8px 16px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  & > .payment-title {
    ${typography.headline2mobile}
    text-align: center;
  }

  & .title {
    display: flex;
    justify-content: center;
    gap: 6px;

    h3 {
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
      text-transform: uppercase;
    }
  }

  & .title-steps {
    display: flex;

    .total-steps {
      color: ${({ theme }) => theme.color2};
    }
  }

  .deposit-button {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    margin-top: 24px;

    button {
      max-width: 280px;

      @media (${device.mobileS}) {
        max-width: 100%;
      }
    }

    .remove-btn {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      color: ${({ theme }) => theme.blackLightColor};
      cursor: pointer;

      @media (hover: hover) {
        &:hover {
          color: ${({ theme }) => theme.blackColor};
        }
      }
    }
  }

  .select-button,
  input,
  textarea {
    background-color: ${({ theme, mode }) =>
      mode === ThemeMode.Dark ? theme.blackColor : theme.whiteColor};
  }

  .fields {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    column-gap: 4px;
    align-items: center;
  }
`;

export const ScConfirmRemoveModal = styled.div`
  margin: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 480px;
  width: 100%;
  background-color: ${({ theme }) => theme.whiteColor};
  color: ${({ theme }) => theme.blackColor};
  border-radius: 8px;
  box-sizing: border-box;
  padding: 32px;

  & > img {
    width: 80px;
    height: 80px;
    margin-bottom: 32px;
  }

  & > h3 {
    font-weight: 700;
    font-size: 22px;
    line-height: 28px;
    letter-spacing: 0.44px;
    text-transform: uppercase;
    margin-bottom: 12px;
    text-align: center;
  }

  & > p {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    width: 100%;
  }

  footer {
    margin-top: 32px;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    gap: 10px;
  }

  @media (${device.mobileS}) {
    max-width: calc(100% - 16px);
    padding: 32px 16px;

    & > h3 {
      font-size: 20px;
      line-height: 26px;
      letter-spacing: 0.4px;
    }
  }
`;

export const ScPaymentInfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  margin-top: 4px;
  border-radius: 16px;
  background: ${({ theme }) => hexToRGB(theme.lightBlue, 0.2)};

  & > i {
    font-size: 24px;
  }

  span {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    color: ${({ theme }) => theme.blackColor};

    @media (${device.mobileS}) {
      color: ${({ theme }) => theme.whiteColor};
    }
  }
`;
